import { Box, useTheme } from "@mui/material"
import { tokens } from "../theme"

export const clientColumns = [
    {
        column:"customer",
        required:true,
    },
    {
        column:"contacperson",
        required:true,
    },
    {
        column:"email",
        required:true,
    },
    {
        column:"phone",
        required:false,
    },
    {
        column:"street",
        required:false,
    },
    {
        column:"house_nr",
        required:false,
    },
    {
        column:"house_nr_extra",
        required:false,
    },
    {
        column:"postal",
        required:false,
    },
    {
        column:"city",
        required:false,
    },
    {
        column:"KVK",
        required:false,
    },
]

export const productColumns = [
    {
        column:"SKU",
        required:true,
    },
    {
        column:"Klant",
        required:true,
    },
    {
        column:"Type",
        columnExplainer:"Voor samenstellingen: 'virtuele samenstelling'. Anders leeg",
        required:false,
    },
    {
        column:"Omschrijving",
        required:true,
    },
    {
        column:"Barcode",
        required:false,
    },
    {
        column:"Gewicht",
        required:false,
    },
    {
        column:"Lengte",
        required:false,
    },
    {
        column:"Breedte",
        required:false,
    },
    {
        column:"Hoogte",
        required:false,
    },
    {
        column:"HS code",
        required:false,
    },
    {
        column:"HTSUS code",
        required:false,
    },
    {
        column:"Land van oorsprong",
        columnExplainer:"2-letterige landcode",
        required:false,
    },
    {
        column:"Kostprijs",
        required:false,
    },
    {
        column:"Prijs",
        required:false,
    },
    {
        column:"Standaard drager",
        required:false,
    },
    {
        column:"Veiligheidsvoorraad",
        required:false,
    },
    {
        column:"Kritische voorraad",
        required:false,
    },
    {
        column:"Inkoopstrategie",
        columnExplainer:"'veiligheidsvoorraad', 'nabestelling', of leeg laten voor geen",
        required:false,
    },
    {
        column:"Marge bij inkopen",
        required:false,
    },
    {
        column:"Partij vereist",
        columnExplainer:"'ja', 'j', of leeg laten voor niet verplicht",
        required:false,
    },
    {
        column:"Batch vereist",
        columnExplainer:"'ja', 'j', of leeg laten voor niet verplicht",
        required:false,
    },
    {
        column:"Leverancier",
        required:false,
    },
    {
        column:"Leverancier SKU",
        columnExplainer:"De SKU die de leverancier voor dit product gebruikt",
        required:false,
    },
    {
        column:"Inactief",
        columnExplainer:"'ja' of 'j' zet het product op inactief. Alleen gebruikt met de optie 'Producten op inactief zetten'",
        required:false,
    },
]

export const virtualProductColumns = [
    {
        column:"Product SKU",
        columnExplainer:"De SKU van de samenstelling",
        required:true,
    },
    {
        column:"Naam samenstelling",
        columnExplainer:"De naam van de samenstelling. Maakt een nog onbekende samenstelling aan, of hernoemt een bestaande",
        required:false,
    },
    {
        column:"Onderdeel SKU",
        columnExplainer:"De SKU van één van de onderdelen van de samenstelling",
        required:true,
    },
    {
        column:"Hoeveelheid",
        columnExplainer:"Hoeveel stuks er van het onderdeel in de samenstelling zitten",
        required:true,
    },
    {
        column:"Klant",
        columnExplainer:"De naam van de relatie",
        required:true,
    },
]

export const locationColumns = [
    {
        column:"Magazijn",
        required:false,
        columnExplainer:"Alleen verplicht als je meerdere magazijnen hebt",
    },
    {
        column:"Magazijnlocatie",
        required:true,
    },
    {
        column:"Zone",
        required:true,
    },
    {
        column:"Locatiesoort",
        required:true,
    },
    {
        column:"Paktafelzone",
        required:false,
        columnExplainer:"Afstand tot de paktafel: 1 (dichtstbij, A-producten) tot en met 3 (verst weg, C-producten)",
    },
]

export const stockColumns = [
    {
        column:"warehouse_location",
        required:true,
    },
    {
        column:"customer",
        required:true,
    },
    {
        column:"sku",
        required:true,
    },
    {
        column:"stock",
        required:true,
    },
    {
        column:"warehouse",
        required:false,
    },
]

// The headers of the move stock import, named exactly as the backend reads them
export const moveStockColumns = [
    {
        column:"Magazijn oud",
        required:false,
        columnExplainer:"Alleen verplicht als je meerdere magazijnen hebt",
    },
    {
        column:"Magazijnlocatie oud",
        required:true,
    },
    {
        column:"Magazijn nieuw",
        required:false,
        columnExplainer:"Alleen verplicht als je meerdere magazijnen hebt",
    },
    {
        column:"Magazijnlocatie nieuw",
        required:true,
    },
    {
        column:"SKU",
        required:true,
    },
]

export const inboundColumns = [
    {
        column:"reference",
        required:true,
    },
    {
        column:"customer",
        required:true,
    },
    {
        column:"warehouse_location",
        required:true,
    },
    {
        column:"amount_expected",
        required:true,
    },
    {
        column:"warehouse",
        required:false,
    },
    {
        column:"amount_received",
        required:false,
    },
]



export const ImportStandAloneFileLogo = ({ Icon }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    return (
        <Box
            sx={{
                height: 32,
                width: 32,
                display: "flex",
                background: theme.palette.mode === "dark" ? colors.blue[100] : colors.primary[100],
                borderRadius: 4,
                alignItems: "center",
                justifyContent: "center",
                "& .logo": {
                    color: theme.palette.mode === "dark" ? colors.blue[400] : colors.primary[400],
                    fill: theme.palette.mode === "dark" ? colors.blue[400] : colors.primary[400],
                    "& *": {
                        fill: theme.palette.mode === "dark" ? colors.blue[400] : colors.primary[400],
                    }
                }
            }}
        >
            <Icon className="logo" fontSize="small"/>
        </Box>
    );
};

// The carriers whose invoice layouts the shipping cost import knows. The value is the
// shipper type the backend keys its column config on.
export const shippingCostShipperOptions = [
    { id: "dhl", name: "DHL eCommerce" },
    { id: "postnl", name: "PostNL" },
    { id: "innosend", name: "Innosend" },
    { id: "innosendv2", name: "Innosend V2" },
    { id: "gls", name: "GLS" },
    { id: "cirro", name: "Cirro" },
    { id: "myparcel", name: "MyParcel" },
];

// The layouts the naheffingen (adjustment charges) import knows. "stockhub" is the sheet the
// fulfilment fills in by hand; the others are carrier invoices, keyed on the shipper type the
// backend keys its column config on.
export const adjustmentChargeShipperOptions = [
    { id: "stockhub", name: "Stockhub" },
    { id: "myparcel", name: "MyParcel" },
    { id: "postnl", name: "PostNL" },
];

// The layouts whose invoice also bills return shipments, which the import charges on only
// when asked to.
export const adjustmentChargeReturnShippers = ["postnl"];

